module.exports = __webpack_public_path__ + "static/media/HomeDepot_logo.7b91469f.svg";